import React, { SyntheticEvent } from 'react';
import './IconButton.css';
import { IonButton } from '@ionic/react';
import clsx from 'clsx';

interface IconButtonProps {
  className?: string;
  id?: string;
  onClick?: (e: SyntheticEvent) => void;
  slot?: string;
  children: React.ReactNode;
}

const IconButton = ({
  children,
  id,
  className,
  onClick,
  slot,
}: IconButtonProps) => (
  <IonButton
    className={clsx('icon-button', className)}
    shape="round"
    fill="outline"
    onClick={onClick}
    {...(id && { id })}
    {...(slot && { slot })}
  >
    {children}
  </IonButton>
);

export default IconButton;
